import { useEffect, useState } from 'react';
import { Contrast } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { getStoredFieldContrast, toggleFieldContrast } from '@/lib/theme';

export const FieldContrastToggle = () => {
  const { t } = useTranslation();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setEnabled(getStoredFieldContrast());
  }, []);

  const label = enabled
    ? t('efs.common.topnav.field_contrast_on')
    : t('efs.common.topnav.field_contrast_off');

  return (
    <Button
      variant={enabled ? 'default' : 'ghost'}
      size="icon"
      onClick={() => setEnabled((prev) => toggleFieldContrast(prev))}
      aria-pressed={enabled}
      aria-label={label}
      title={label}
    >
      <Contrast className="h-4 w-4" />
    </Button>
  );
};
